import type { CodesDetail, ProductParams } from '@/api/model/basicTypes'
import type { Mutation } from 'vuex'
import type { State } from '.'

import { actionTypes } from '.'
import { deepCopy } from '@/utils'

export default <{ [actionType: string]: Mutation<State> }>{
  [actionTypes.SET_FOLDER_NAME](state, value: string): void {
    state.folderName = value
  },

  [actionTypes.SET_FILE_NAME](state, value: string): void {
    state.fileName = value
  },

  [actionTypes.SET_DOCUMENT_TYPE_INFO](state, info: CodesDetail): void {
    state.documentTypeInfo = deepCopy(info)
  },

  [actionTypes.SET_DOCUMENT_TYPE](state, value: string): void {
    state.documentType = value
  },
  [actionTypes.SET_PRODUCT_TABLE](state, value: string): void {
    state.productTable = value
  },

  // 商品一覧画面・検索条件
  [actionTypes.SET_PRODUCT_LIST_PARAM](state, value: ProductParams): void {
    state.productListParam = value
  },
}
